import { Ratings as Ratings$2 } from './Ratings.style.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import useIsGlobetrotter from '../../../hooks/useIsGlobetrotter.js';
import Rating from '../../Rating/Rating.js';
import GuestRating from '../../GuestRating/GuestRating.js';
import TripadvisorRating from '../../TripadvisorRating/TripadvisorRating.js';

var Ratings = function Ratings(_ref) {
  var _ref$rating = _ref.rating,
    rating = _ref$rating === void 0 ? null : _ref$rating,
    _ref$ratingPrefix = _ref.ratingPrefix,
    ratingPrefix = _ref$ratingPrefix === void 0 ? null : _ref$ratingPrefix,
    _ref$guestRating = _ref.guestRating,
    guestRating = _ref$guestRating === void 0 ? null : _ref$guestRating,
    _ref$tripadvisorRatin = _ref.tripadvisorRating,
    tripadvisorRating = _ref$tripadvisorRatin === void 0 ? null : _ref$tripadvisorRatin;
  var isGlobetrotter = useIsGlobetrotter();
  return /*#__PURE__*/jsxs(Ratings$2, {
    children: [rating && /*#__PURE__*/jsxs(Fragment, {
      children: [ratingPrefix && /*#__PURE__*/jsx("span", {
        children: ratingPrefix
      }), /*#__PURE__*/jsx(Rating, {
        size: "s",
        rating: rating
      })]
    }), !!guestRating && !isGlobetrotter && /*#__PURE__*/jsx(GuestRating, {
      rating: guestRating
    }), !!tripadvisorRating && /*#__PURE__*/jsx(TripadvisorRating, {
      rating: tripadvisorRating
    })]
  });
};
var Ratings$1 = Ratings;

export { Ratings$1 as default };
//# sourceMappingURL=Ratings.js.map
